import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ControllerListarPacientesCitas } from "../../Service/Service.paciente";
import { json } from "react-router-dom";
import ResumenCitas from "./ResumenCitas";


export default function Inicio() {
  const [infoCita, setInfoCita] = useState(null);
  const [ping, setPing] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      // sacar el id del paciente de la url ?idpaciente=1
      const urlParams = new URLSearchParams(window.location.search);
      const idpaciente = urlParams.get("idpaciente");
      const cit = await ControllerListarPacientesCitas(idpaciente);
      if (cit.success) {
        setInfoCita(cit.data);
        console.log("555",cit.data);
      }
    })();
  }, []);

  /*const handleConsultarPacienteCita = (idcita) => {
    const urlParams = new URLSearchParams(window.location.search);
    const idpaciente = urlParams.get("idpaciente");
    let path = `/paciente_historial?idpaciente=${idpaciente}&idcita=${idcita}`;
    window.history.pushState({}, "", path);
    document.getElementById("medicina-tab").click();
    window.open(path, "_blank");
    dispatch({
      type: "SET_HISTORIAL",
      payload: !ping,
    });
  };*/
  const handleConsultarPacienteCita = (idcita) => {
    const urlParams = new URLSearchParams(window.location.search);
    const idpaciente = urlParams.get("idpaciente");
    const path = `/paciente_historial?idpaciente=${idpaciente}&idcita=${idcita}`;
  
    // ✅ Abre en nueva pestaña
    window.open(path, "_blank");
  
    // 👇 Esto solo se queda si quieres actualizar algo en esta ventana también
    dispatch({
      type: "SET_HISTORIAL",
      payload: !ping,
    });
  };
  
  const handleLlamarPaciente = async (cita) => {
      try {
      //alert(JSON.stringify(cita));

        console.log("infocita",infoCita);
        // Datos de la cita, reemplazar con los valores adecuados
        const data = {
          topic: "turnero",
          user: "turnero_user",
          pass: "turnero123",
          message: {
            modulo: [cita.doctor.prefijo, cita.doctor.consultorio]
              .filter(Boolean) // 🔥 Elimina valores `null` o `undefined`
              .join(""), // 🔥 Une los valores sin espacios extra
                    turno: infoCita?.nombres_completos,
            hora: new Date().toLocaleTimeString(),
            doctor: cita.doctor.nombre, 
            estado: "En consulta",
            especialidad: cita.idespecialidad || "No especificada",
          },
        };
        
    
        const response = await fetch("https://colon.smartmedic.site/moquito/api/mqtt", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
    
        if (!response.ok) {
          throw new Error(`Error al enviar la solicitud: ${response.statusText}`);
        }
    
        const result = await response.json();
        console.log("Solicitud POST exitosa:", result);
        //alert("Llamado exitoso al paciente con ID " + cita);
      } catch (error) {
        console.error("Error en handleLlamarPaciente:", error);
        alert("Error al llamar al paciente.");
      }
  };
  
  
  const handleVerDetalleCita = (idcita) => {
    window.location.href = `/detalle-cita?idcita=${idcita}`;
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-3 col-lg-4">
          <div className="card">
          <div className="card-body">
            <div className="d-flex flex-column align-items-center gap-3 font-size-16">
              {/* }
              <div
                className="d-flex justify-content-center align-items-center rounded-circle border shadow-lg bg-light"
                style={{
                  width: "120px",
                  height: "120px",
                  overflow: "hidden",
                }}
              >
                {infoCita &&
                  infoCita.multimedia.map((multimedia, index) => {
                    if (multimedia.ruta === "foto_paciente") {
                      return (
                        <img
                          key={index + 1}
                          src={multimedia.url}
                          alt="Foto del paciente"
                          className="img-fluid"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      );
                    }
                    return null;
                  })}
              </div>
              {*/}

              {/* Información del paciente */}
              <div className="w-100 text-center">
                {/* Tipo Paciente */}
                <div className="p-2 mb-1 rounded bg-success text-white">
                  <strong>Tipo Paciente:</strong> {infoCita?.tipo_seguros.tipo || "No disponible"}
                </div>
                {/* Nombre seguro */}
                {/* Mostrar solo si tipo de paciente es SEGURO */}
                {infoCita?.tipo_seguros?.tipo?.toUpperCase() === "SEGUROS" && (
                  <div className="p-2 mb-1 rounded bg-danger text-white">
                    <strong>Seguro:</strong> {infoCita?.seguros?.nombre || "No disponible"}
                  </div>
                )}
                {/* Nombre */}
                <div className="p-2 mb-1 rounded bg-primary text-white">
                  <strong>Paciente:</strong> {infoCita?.nombres_completos || "No disponible"}
                </div>
                {/* Teléfono */}
                <div className="p-2 mb-1 rounded bg-success text-white">
                  <strong>Celular:</strong> {infoCita?.celular || "No disponible"}{" "}
                  <i className="fas fa-mobile-alt ms-1"></i>
                </div>

                {/* Correo electrónico */}
                <div className="p-2 mb-1 rounded bg-warning text-dark">
                  <strong>Email:</strong> {infoCita?.email || "No disponible"}{" "}
                  <i className="far fa-envelope ms-1"></i>
                </div>

                {/* Edad */}
                <div className="p-2 mb-1 rounded bg-info text-white">
                  <strong>Edad:</strong> {infoCita?.edad || "No disponible"} años{" "}
                  <i className="fas fa-calendar-alt ms-1"></i>
                </div>
              </div>
            </div>
          </div>

          </div>
        </div>

        <div className="col-xl-9 col-lg-8">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-3">Listado de Citas</h5>
              <small className="text-muted">Ultimas 5 citas</small>

              <div>
                <table
                  id="tb_resumen_citas"
                  className="table table-sm"
                  style={{
                    fontSize: "13px",
                  }}
                >
                  <thead>
                    <tr>
                      <td>Fecha</td>
                      <td>Hora</td>
                      <td>Doctor</td>
                      <td>Estado</td>
                      <td>Opcion</td>
                    </tr>
                  </thead>
                  <tbody>
                    {infoCita &&
                      infoCita.citas.map((cita, index) => (
                        <tr key={index}>
                          <td>{cita.fecha_inicio}</td>
                          <td>{cita.hora_inicio}</td>
                          <td>{cita.doctor?.nombre || "Sin doctor"}</td>

                          <td>
                          <span
                            className={`${
                              cita.estado_cita.estado === "Sin Confirmar"
                                ? "badge bg-secondary"
                                : cita.estado_cita.estado === "Confirmado"
                                ? "badge bg-primary"
                                : cita.estado_cita.estado === "En sala de espera" || cita.estado_cita.estado === "En Consulta"
                                ? "badge bg-warning"
                                : cita.estado_cita.estado === "Finalizada"
                                ? "badge bg-success"
                                : cita.estado_cita.estado === "Cancelada" || cita.estado_cita.estado === "Eliminada"
                                ? "badge bg-danger"
                                : "badge bg-secondary"
                            } px-3 py-2 mt-1 fw-bold fs-6 rounded-pill shadow-sm`}
                          >
                            {cita.estado_cita.estado}
                          </span>


                          </td>
                          <td>
                            <span
                              className="btn btn-sm btn-soft-primary cursor-pointer rounded-pill shadow-sm"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleConsultarPacienteCita(cita.idcita)}
                            >
                              {cita.ver_citas ? (
                                <span title="Consultar cita">
                                  Consultar
                                  <i className="fas fa-eye mx-1"></i>
                                </span>
                              ) : (
                                <span title="Ver detalle de la cita">
                                  Ver
                                  <i className="fas fa-eye mx-1"></i>
                                </span>
                              )}
                            </span>

                            {/* Nuevo botón "Llamar" */}
                            <span
                              className="btn btn-sm btn-soft-success cursor-pointer ms-2 rounded-pill shadow-sm"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleLlamarPaciente(cita)}
                            >
                              <span title="Llamar al paciente">
                                Llamar
                                <i className="fas fa-ticket-alt mx-1"></i>
                              </span>
                            </span>
                          </td>

                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* eliminado por no registran tratamientos 
           */}
        </div>
        {/*}
        <div className="col-xl-3 col-lg-4">
          <div className="card bg-danger border-danger text-white-50">
            <div className="card-body">
              <div>
                <h5 className="mb-2 text-white"> TOTAL DEUDA</h5>
              </div>
              <div>
                {" "}
                <h3 id="resumen-deuda" className="text-end text-white">
                  {" "}
                  0.00{" "}
                </h3>{" "}
              </div>
            </div>
          </div>

          <div className="card bg-success border-success text-white-50">
            <div className="card-body">
              <div>
                <h5 className="mb-2 text-white"> SALDO A FAVOR</h5>
              </div>
              <div>
                {" "}
                <h3 id="resumen-saldo-favor" className="text-end text-white">
                  {" "}
                  0.00{" "}
                </h3>{" "}
              </div>
            </div>
          </div>
        </div>
        {*/}
      </div>
      <ResumenCitas
        citas={infoCita?.citas || []}
        onConsultar={handleConsultarPacienteCita}
        onLlamar={handleLlamarPaciente}
      />
    </>
  );
}
